import { create } from 'zustand';
import { NavigateOptions } from 'react-router-dom';

type BreadcrumbItem = {
  icon?: React.ReactNode;
  title?: React.ReactNode;
  navigateOptions?: NavigateOptions;
  href?: string;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
};

export type NavigationStore = {
  title?: React.ReactNode;
  breadcrumb?: BreadcrumbItem[];
  setPageHeader: (
    params: Pick<NavigationStore, 'breadcrumb' | 'title'>
  ) => void;
};

export const useNavigationStore = create<NavigationStore>((set) => ({
  title: undefined,
  breadcrumb: undefined,
  setPageHeader: ({ title, breadcrumb }) => set({ title, breadcrumb }),
}));
